import React from "react";
import { Loja } from "../../../../types/loja";

interface LojaSelectorProps {
  lojas: Loja[];
  selectedLojaId?: number;
  showLojaSelector: boolean;
  onSelectAllLojas?: () => void;
  onSelectLoja?: (id: number) => void;
}

export const LojaSelector: React.FC<LojaSelectorProps> = ({
  lojas,
  selectedLojaId,
  showLojaSelector,
  onSelectAllLojas,
  onSelectLoja,
}) => {
  if (!showLojaSelector || lojas.length === 0) {
    return null;
  }

  return (
    <div className="fixed left-2 right-2 top-14 z-40 max-h-[70vh] min-w-0 overflow-y-auto rounded-lg bg-black/90 p-3 shadow-xl backdrop-blur-sm sm:left-4 sm:right-auto sm:max-h-none sm:min-w-48 sm:p-4">
      <h3 className="mb-2 text-sm font-semibold text-white sm:text-base">
        Selecionar Loja:
      </h3>
      <div className="space-y-1">
        <button
          type="button"
          onClick={onSelectAllLojas}
          className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
            !selectedLojaId
              ? "bg-red-600 text-white"
              : "bg-white/10 text-white hover:bg-white/20"
          }`}
        >
          Todas as Lojas
        </button>
        {lojas.map((loja) => (
          <button
            key={loja.id}
            type="button"
            onClick={() => onSelectLoja?.(loja.id)}
            className={`w-full rounded px-3 py-2 text-left text-sm transition-colors ${
              selectedLojaId === loja.id
                ? "bg-red-600 text-white"
                : "bg-white/10 text-white hover:bg-white/20"
            }`}
          >
            {loja.nome}
          </button>
        ))}
      </div>
    </div>
  );
};
